import React from "react"
import tw, { css, styled } from "twin.macro"

interface Props {
  createButtonClicked?: () => void
  closeButtonClicked?: () => void
}

const NSNModalDetail: React.FC<Props> = ({closeButtonClicked, createButtonClicked}) => (
  <div
    css={[
      css`
        max-width: 16.8rem;
      `,
      tw`flex flex-wrap flex-row justify-center p-4 font-sans text-black text-center text-xs`,
    ]}
  >
    <Paragraph>
      If you do not know your NSN number, you can contact NZQA on{" "} <a css={[tw`underline whitespace-no-wrap`]} href="tel:0800 697 296">0800 697 296</a>
      {" "}or complete the form at{" "}
      <a
        css={[tw`underline`]}
        href="https://www.nzqa.govt.nz/about-us/contact-us/the-call-centre-nsn-2/"
        target="_blank"
      >
        https://www.nzqa.govt.nz/about-us/contact-us/the-call-centre-nsn-2/
      </a>.
    </Paragraph>
    <Button onClick={closeButtonClicked}>
      I know my NSN number
    </Button>
    <Paragraph>
      If you do not have an NSN number, we can create one for you. You will need to upload a copy of your birth certificate or passport.
    </Paragraph>
    <Button onClick={createButtonClicked}>
      Create an NSN number
    </Button>
  </div>
)

const Paragraph = styled.p`
  ${tw`mb-4 mt-4 last:mb-0`}
`
const Button = styled.button`
  ${tw`font-licenz bg-brand-yellow rounded text-black px-4 py-1 uppercase hover:bg-black hover:text-white focus:outline-none border border-2 border-transparent focus:border-black mb-4 last:mb-0`}
`
export default NSNModalDetail
